import { useState, useEffect } from 'react';

import Loading from "../../components/Loading";

import Item from './components/Item';

import Data from '../../../repository';

import styles from '../../../styles/Admin.module.scss';

function List() {
	const [loading, setLoading] = useState(true);
	const [coupons, setCoupons] = useState([]);

	useEffect(async () => {
		await refreshCoupons();
	}, [])

	const refreshCoupons = async () => {
		setLoading(true);
		let coupons = await Data.fetchCoupons();
		setCoupons(coupons.data);
		setLoading(false);
	}

	if(loading) return <Loading button={false} />

	return (
		<div className={styles.list}>
			{!coupons.length && <div><p>There aren't any coupons to show.</p></div>}

			{coupons.map((coupon) => {
				return <Item {...coupon} />
			})}
		</div>
	)
}

export default List;